import { render, staticRenderFns } from "./StoriesArticleStars.vue?vue&type=template&id=69ab15d4&scoped=true&"
import script from "./StoriesArticleStars.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleStars.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleStars.vue?vue&type=style&index=0&id=69ab15d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ab15d4",
  null
  
)

export default component.exports